/**
 * Money, written the way a person reads it.
 *
 * The database keeps these as doubles, and one of them (data_log.paid_amount) as text, so a
 * total can arrive as 1200, "1200.00" or null. Anything that is not a number reads as an em
 * dash rather than "$NaN" or a confident "$0.00" — a family who has not paid and a family who
 * paid nothing are different things.
 */
export const formatMoney = (value, { blankWhenMissing = true } = {}) => {
    if (value === null || value === undefined || value === '') {
        return blankWhenMissing ? '—' : '$0.00';
    }

    const number = Number(value);
    if (!Number.isFinite(number)) {
        return blankWhenMissing ? '—' : '$0.00';
    }

    return number.toLocaleString('en-AU', {
        style: 'currency',
        currency: 'AUD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

/** "24 Sep 2026, 2:03 pm" — or nothing, when the date was never recorded. */
export const formatWhen = (value) => {
    if (!value) return '';

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);

    return date.toLocaleString('en-AU', {
        day: 'numeric', month: 'short', year: 'numeric',
        hour: 'numeric', minute: '2-digit',
    });
};
